import React from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

function BlockLoading({ height, style }) {
  return (
    <div style={{height}}>
      <Spinner style={style} />
    </div>
  )
}

BlockLoading.propTypes = {
  height: PropTypes.any,
  style: PropTypes.object
}

export default BlockLoading;
